import Link from 'next/link';
import { useRouter } from 'next/router';
import { Text, cn } from '@typedream/ui';

import Logo from '@/sharedComponents/Logo';
import LoginSignupForm from '@/components/LoginSignupForm';

import { NEW_LOGO_WITH_TEXT_URL, PRIVACY_POLICY_LINK, TERMS_OF_SERVICE_LINK } from '@/constants';
import animationStyles from '@/styles/Animation.module.css';
import Image from 'next/image';

function SignupSection({ bypass }: { bypass: boolean }) {
  const router = useRouter();

  return (
    <>
      <Image
        src="/images/new_logo_svg.svg"
        alt=""
        width={104.61}
        height={20}
        className="absolute md:hidden top-[65px] left-[23px]"
      />
      <div
        className={cn(
          'flex flex-col justify-center md:justify-start items-start w-full max-w-[414px] py-10 gap-[9px] md:gap-0 px-4 md:px-0',
          animationStyles.fadeInFromBottom
        )}
      >
        <div className="hidden md:block">
          <Logo logoURL={NEW_LOGO_WITH_TEXT_URL} link="/" width={156} height={40} />
        </div>

        <Text
          as="p"
          className="mt-7 mb-3 text-2xl max-w-[305px] md:text-[28px] md:tracking-tigh md:max-w-none"
          weight="semibold"
          variant="main"
        >
          Create Account
        </Text>
        <Text className="mb-9 text-[13px] leading-5 md:text-sm">
          By signing up, you agree to our{' '}
          <a href={TERMS_OF_SERVICE_LINK} target="_blank" rel="noreferrer">
            <Text as="span" variant="link" size="sm" weight="semibold">
              Terms of Service
            </Text>
          </a>{' '}
          and{' '}
          <a href={PRIVACY_POLICY_LINK} target="_blank" rel="noreferrer">
            <Text as="span" variant="link" size="sm" weight="semibold">
              Privacy Policy
            </Text>
          </a>
        </Text>
        <LoginSignupForm login={false} redirect />
        <Text className="my-3" size="sm" weight="medium">
          Already have an account?{' '}
          <Link
            href={{
              pathname: '/login',
              query: router.query,
            }}
          >
            Log in
          </Link>
        </Text>
      </div>
    </>
  );
}

export default SignupSection;
